module.exports = "images/footer.svg";